import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputDisplayTemplate from '../../components/InputDisplayTemplate'

const SingleParentInformation = ({ singleParentInfo }) => {
  return (
    <>
      <div className="row d-flex  mb-1 p-3" style={{height:'500px', overflowY:'scroll', }}>
        <h3 className="cms-text-primary font-weight-bold py-2">Solo Parent Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Category" dataItem={_.get(singleParentInfo, 'attributes.category_name') || '- -'} />
        </div>
        <h3 className="cms-text-primary font-weight-bold py-2">Assistance</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Financial Assistance" dataItem={_.get(singleParentInfo, 'attributes.with_financial_assistance') ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Skills Training" dataItem={_.get(singleParentInfo, 'attributes.with_skills_training') ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Livelihood Assistance" dataItem={(_.get(singleParentInfo, 'attributes.with_livelihood_assistance')) ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Others" dataItem={_.get(singleParentInfo, 'attributes.other_program') || '- -'} />
        </div>
        <h3 className="cms-text-primary font-weight-bold py-2">Personal Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(singleParentInfo, 'attributes.last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(singleParentInfo, 'attributes.first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(singleParentInfo, 'attributes.middle_name'))  || '- -'} />
          <InputDisplayTemplate title="Suffix" dataItem={_.get(singleParentInfo, 'attributes.extension_name') || '- -'} />
          <InputDisplayTemplate title="Gender" dataItem={_.get(singleParentInfo, 'attributes.gender') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(singleParentInfo, 'attributes.birth_date') || '- -'} />
          <InputDisplayTemplate title="Age" dataItem={(_.get(singleParentInfo, 'attributes.age'))  || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Contact Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Email Address" dataItem={(_.get(singleParentInfo, 'attributes.email'))  || '- -'} />
          <InputDisplayTemplate title="Mobile Number" dataItem={(_.get(singleParentInfo, 'attributes.mobile_number')) || '- -'} />
          <InputDisplayTemplate title="Telephone Number" dataItem={_.get(singleParentInfo, 'attributes.telephone_number') || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Address</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(singleParentInfo, 'attributes.region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(singleParentInfo, 'attributes.province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(singleParentInfo, 'attributes.municipality_name') || '- -'} />
          <InputDisplayTemplate title="Barangay" dataItem={_.get(singleParentInfo, 'attributes.barangay_name') || '- -'} />
          <InputDisplayTemplate title="Zone" dataItem={_.get(singleParentInfo, 'attributes.zone') || '- -'} />
          <InputDisplayTemplate title="Unit No. / House No. / Street Name" dataItem={_.get(singleParentInfo, 'attributes.address') || '- -'} />
        </div>
        
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Place of Birth</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(singleParentInfo, 'attributes.place_of_birth_region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(singleParentInfo, 'attributes.place_of_birth_province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(singleParentInfo, 'attributes.place_of_birth_municipality_name') || '- -'} />
        </div>
        <h2 className="col-12 cms-text-primary font-weight-bold pb-2 pt-3">Family Information</h2>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Mothers Maiden Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(singleParentInfo, 'attributes.mother_maiden_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(singleParentInfo, 'attributes.mother_maiden_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(singleParentInfo, 'attributes.mother_maiden_middle_name')) || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Fathers Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(singleParentInfo, 'attributes.father_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(singleParentInfo, 'attributes.father_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(singleParentInfo, 'attributes.father_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Spouse Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(singleParentInfo, 'attributes.spouse_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(singleParentInfo, 'attributes.spouse_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(singleParentInfo, 'attributes.spouse_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Identity Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Height" dataItem={_.get(singleParentInfo, 'attributes.height') || '- -'} />
          <InputDisplayTemplate title="Weight" dataItem={_.get(singleParentInfo, 'attributes.weight') || '- -'} />
          <InputDisplayTemplate title="Complexion" dataItem={(_.get(singleParentInfo, 'attributes.complexion'))  || '- -'} />
          <InputDisplayTemplate title="Country of Citizenship" dataItem={(_.get(singleParentInfo, 'attributes.citizenship_code'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Educational Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Highest Educational Attainment" dataItem={_.get(singleParentInfo, 'attributes.educational_attainment') || '- -'} />
          <InputDisplayTemplate title="Institution" dataItem={_.get(singleParentInfo, 'attributes.institution_name') || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Valid ID</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Type of Valid ID" dataItem={_.get(singleParentInfo, 'attributes.id_type') || '- -'} />
          <InputDisplayTemplate title="Valid ID" dataItem={_.get(singleParentInfo, 'attributes.id_url') || '- -'} isImage />
        </div>
      </div>
    </>
  );
};

SingleParentInformation.propTypes = {
  singleParentInfo: PropTypes.instanceOf(Object).isRequired,
};

export default SingleParentInformation;
